import { Component, OnInit, OnDestroy, inject, effect } from '@angular/core';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { VideoUploadComponent } from "../../features/video/view/video-upload/video-upload.component";
import { VideoQueryElementsComponent } from "../../features/handball/video-quering/view/video-query-elements/video-query-elements.component";
import { QueryElementsConfig } from 'src/app/features/handball/video-quering/model/query-elements-config';
import { CommonModule } from '@angular/common';
import { FilterModel } from 'src/app/features/handball/video-quering/model/filter-model';
import { FormsModule } from '@angular/forms';
import { VideoUploadStore } from './store/upload.store';
import { ProgressBarComponent } from "../../fragments/progress-bar/progress-bar.component";
import { MatIconModule } from '@angular/material/icon';
import { Season, StatisticsService } from '@solverml/api';

@Component({
  selector: 'app-upload-video',
  templateUrl: 'upload-video.component.html',
  styleUrls: ['upload-video.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, VideoUploadComponent, VideoQueryElementsComponent, ProgressBarComponent, MatIconModule]
})
export class UploadVideoComponent implements OnInit, OnDestroy {

  store = inject(VideoUploadStore);
  router = inject(Router);
  private statisticsService = inject(StatisticsService);

  filters: FilterModel = {
    gender: '',
    category: '',
    competition: '',
    dateStart: '',
    dateEnd: ''
  };
  queryElementsConfig: QueryElementsConfig;
  seasons: Season[] = [];

  otherCategory: string;
  otherCompetition: string;
  otherChampionship: string;

  constructor() {
    effect(() => {
      const editing = this.store.editingVideo();
      if (editing) {
        this.filters = {
          gender: editing.gender,
          category: editing.category,
          competition: editing.competition,
          dateStart: '',
          dateEnd: ''
        };
      }
    }, { allowSignalWrites: true });
  }

  ngOnInit() {
    this.queryElementsConfig = {
      gender: { visible: true },
      category: { visible: true, allowOtherCustomField: true },
      competition: { visible: true, allowOtherCustomField: true },
      dateStart: { visible: false },
      dateEnd: { visible: false },
    };

    this.loadSeasons();
  }

  ngOnDestroy() {
    this.store.clear();
  }

  protected onFiltersChange(filter: FilterModel) {
    this.filters = filter;
  }

  async uploadAll() {
    await this.store.uploadAll();
  }

  removeVideo(id: string) {
    this.store.removeVideo(id);
  }

  editVideo(id: string) {
    this.store.setEditingVideo(id);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  goToAnalysis() {
    this.router.navigate(['/analysis']);
  }

  uploadMore() {
    this.store.clear();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  private async loadSeasons(): Promise<void> {
    try {
      this.seasons = await firstValueFrom(this.statisticsService.getSeasonsEndpoint());
    } catch (error) {
      console.error('No se pudieron cargar las temporadas para upload.', error);
      this.seasons = [];
    }
  }
}
